// app/pages/profileMembers/components/ProfileMemberMeta.tsx
import { CSSProperties, FC, useState } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useMemberGuide } from '../../../hooks/manageMembers/useMemberGuide'
import { useMemberStatus } from '../../../hooks/manageMembers/useMemberStatus'
import { useMemberTier } from '../../../hooks/manageMembers/useMemberTier'
import { useMemberTierList } from '../../../hooks/manageMembers/useMemberTierList'
import { defaultProfileImage } from '../../../utils/constants'
import { ApiMember } from '../../manageMembers/models/ManageMemberModel'
import { ProfileMemberGuideModal } from './memberGuide/ProfileMemberGuideModal'
import { ProfileMemberStatusAction } from './membersMeta/ProfileMemberStatusAction'

interface ProfileMemberMetaProps {
  assignedAdmin?: string
  plan?: string
  styles?: CSSProperties;
  userId?: number;
  username?: string;
}

export const ProfileMemberMeta: FC<ProfileMemberMetaProps> = ({
  assignedAdmin,
  plan,
  styles,
  username,
  userId
}) => {
  const [showMemberGuide, setShowMemberGuide] = useState(false);
  const [banMode, setBanMode] = useState(false);
  const { memberGuide, updateMemberGuide, loading: loadMemberGuide } = useMemberGuide(userId);
  const { list: tierCatalog, loading: loadTierCatalog } = useMemberTierList();
  const { loading: loadUserTier, memberTier, updateMemberTier } = useMemberTier(userId);
  const { loading: loadStatus, status, banUser, reload: reloadStatus } = useMemberStatus(userId);

  const _handleUpdateMemberGuide = (member: ApiMember | null) => {
    updateMemberGuide(member ? member.id : null);
    setShowMemberGuide(false);
  }

  return (
    <>
      {banMode && userId && (
        <ProfileMemberStatusAction
          onCloseModal={() => setBanMode(false)} 
          reloadStatus={reloadStatus}
          userId={userId}  
          username={username ?? ""}
          banUser={banUser}
          showModal={banMode}
          status={status} 
        />
      )}
      <ProfileMemberGuideModal
        show={showMemberGuide}
        onHide={() => setShowMemberGuide(false)}
        onUpdate={_handleUpdateMemberGuide}
        defaulValue={memberGuide}
      />
      <div className='nb-pm-meta-container' style={styles}>
        <svg
          width='100%' // CAMBIADO de 1060
          height='1'
          viewBox='0 0 1060 1'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          preserveAspectRatio='none' // AGREGADO
        >
          <path d='M1060 0.5L2.67029e-05 0.499954' stroke='#E9E9E9' />
        </svg>

        <div className='nb-pm-meta'>
          <div className='nb-pm-meta__group'>
            <div className='nb-pm-meta__label'>Assign Admin</div>
            <div className='nb-pm-meta__value'>{assignedAdmin || 'John Doe'}</div>
          </div>

          <div className='nb-pm-meta__group'>
            <div className='nb-pm-meta__label'>Plan</div>
            <div className='nb-pm-meta__value'>{plan || 'Electi'}</div>
          </div>

          <div className='nb-pm-meta__group'>
            <div className="nb-pm-meta__label">New Member Guide</div>
            <div className='nb-pm-meta__action' onClick={() => setShowMemberGuide(true)}>
              {loadMemberGuide ? <span>Loading...</span>: (
                <>
                { memberGuide ? (
                  <>
                    <img src={toAbsoluteUrl(memberGuide.profilePicture) } onError={(e) => { e.currentTarget.src = defaultProfileImage }} />
                    <span>
                      {`${memberGuide.firstName} ${memberGuide.lastName}`}
                    </span>
                  </>
                ):(
                  <>
                    N/A
                  </>
                )}
                </>
              )}
            </div>
          </div>

          <div className='nb-pm-meta__group'>
            <div className="nb-pm-meta__label">Member Tier</div>
            <select className='nb-pm-meta__select' 
              value={memberTier?.id ?? ""}
              onChange={e => updateMemberTier(!!Number(e.target.value) ? Number(e.target.value): null)}
              disabled={loadTierCatalog || loadUserTier}
            >
              <option value="" selected>-</option>
              { tierCatalog.map(((t, i) => 
                <option value={t.id} key={t.id}>{t.code}</option>
              ))}
            </select>
          </div>

          <div className='nb-pm-meta__group'>
            <div className="nb-pm-meta__label">Status</div>
            <div className='nb-pm-meta__action' 
              onClick={() => { 
                if(loadStatus) 
                  return; 
                setBanMode(true); 
              }}
            >
              { loadStatus ? 'Loading...' : status?.status ?? 'N/A'}
            </div>
          </div>
        </div>

        <svg
          width='100%' // CAMBIADO de 1060
          height='1'
          viewBox='0 0 1060 1'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          preserveAspectRatio='none' // AGREGADO
        >
          <path d='M1060 0.5L2.67029e-05 0.499954' stroke='#E9E9E9' />
        </svg>
      </div>
    </>
  )
}